module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers",
    attrs: {
      "id": "pers-tab2-6",
      "name": "hres32e-tab2-tab6"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 pull-left"
  }, [_c('div', {
    staticClass: "col-xs-12 card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic1
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC16']['20']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic1),
      expression: "subTopic1"
    }],
    staticClass: "data-box clearfix"
  }, [_vm._l((_vm.detail.table1.rows), function(value, index) {
    return [_c('div', {
      staticClass: "table-row clearfix"
    }, [_c('div', {
      staticClass: "col-xs-12 body-table-left color-skin"
    }, [_vm._v(_vm._s(value.coddeduct) + " - " + _vm._s(value.desdeduct))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 body-table-right"
    }, [_c('div', {
      staticClass: "data-table-row"
    }, [_c('div', {
      staticClass: "col-xs-5 table-label"
    }, [_vm._v(_vm._s(_vm.labels['HRES32EC16']['50']))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 table-input"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (value.amtdeduct),
        expression: "value.amtdeduct"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('decimal:2|max:12'),
        expression: "'decimal:2|max:12'"
      }],
      staticClass: "form-control input-text",
      attrs: {
        "type": "text",
        "maxlength": "12",
        "data-vv-name": 'amtdeduct-1-' + index,
        "data-vv-as": 'amtdeduct-1-' + index,
        "has-error": _vm.errors.has('amtdeduct-1-' + index)
      },
      domProps: {
        "value": (value.amtdeduct)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(value, "amtdeduct", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon input-group-addon-cust"
    }, [_vm._v(_vm._s(_vm.constLabels[_vm.nowLang]['bath']))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('amtdeduct-1-' + index)),
        expression: "errors.has('amtdeduct-1-' + index)"
      }],
      staticClass: "text-error"
    }, [_vm._v(_vm._s(_vm.errors.first('amtdeduct-1-' + index)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 body-table-right"
    }, [_c('div', {
      staticClass: "data-table-row"
    }, [_c('div', {
      staticClass: "col-xs-5 table-label"
    }, [_vm._v(_vm._s(_vm.labels['HRES32EC16']['50']) + " (" + _vm._s(_vm.constLabels[_vm.nowLang]['spouse']) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 table-input"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (value.amtdeduct_spous),
        expression: "value.amtdeduct_spous"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('decimal:2|max:12'),
        expression: "'decimal:2|max:12'"
      }],
      staticClass: "form-control input-text",
      attrs: {
        "type": "text",
        "maxlength": "12",
        "data-vv-name": 'amtdeduct_spous-1-' + index,
        "data-vv-as": 'amtdeduct_spous-1-' + index,
        "has-error": _vm.errors.has('amtdeduct_spous-1-' + index)
      },
      domProps: {
        "value": (value.amtdeduct_spous)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(value, "amtdeduct_spous", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon input-group-addon-cust"
    }, [_vm._v(_vm._s(_vm.constLabels[_vm.nowLang]['bath']))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('amtdeduct_spous-1-' + index)),
        expression: "errors.has('amtdeduct_spous-1-' + index)"
      }],
      staticClass: "text-error"
    }, [_vm._v(_vm._s(_vm.errors.first('amtdeduct_spous-1-' + index)))])])])])])]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 pull-right"
  }, [_c('div', {
    staticClass: "col-xs-12 card-ui card-ui-right clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic2
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC16']['100']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic2),
      expression: "subTopic2"
    }],
    staticClass: "data-box clearfix"
  }, [_vm._l((_vm.detail.table2.rows), function(value, index) {
    return [_c('div', {
      staticClass: "table-row clearfix"
    }, [_c('div', {
      staticClass: "col-xs-12 body-table-left color-skin"
    }, [_vm._v(_vm._s(value.coddeduct) + " - " + _vm._s(value.desdeduct))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 body-table-right"
    }, [_c('div', {
      staticClass: "data-table-row"
    }, [_c('div', {
      staticClass: "col-xs-5 table-label"
    }, [_vm._v(_vm._s(_vm.labels['HRES32EC16']['50']))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 table-input"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (value.amtdeduct),
        expression: "value.amtdeduct"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('decimal:2|max:12'),
        expression: "'decimal:2|max:12'"
      }],
      staticClass: "form-control input-text",
      attrs: {
        "type": "text",
        "maxlength": "12",
        "data-vv-name": 'amtdeduct-2-' + index,
        "data-vv-as": 'amtdeduct-2-' + index,
        "has-error": _vm.errors.has('amtdeduct-2-' + index)
      },
      domProps: {
        "value": (value.amtdeduct)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(value, "amtdeduct", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon input-group-addon-cust"
    }, [_vm._v(_vm._s(_vm.constLabels[_vm.nowLang]['bath']))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('amtdeduct-2-' + index)),
        expression: "errors.has('amtdeduct-2-' + index)"
      }],
      staticClass: "text-error"
    }, [_vm._v(_vm._s(_vm.errors.first('amtdeduct-2-' + index)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 body-table-right"
    }, [_c('div', {
      staticClass: "data-table-row"
    }, [_c('div', {
      staticClass: "col-xs-5 table-label"
    }, [_vm._v(_vm._s(_vm.labels['HRES32EC16']['50']) + " (" + _vm._s(_vm.constLabels[_vm.nowLang]['spouse']) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 table-input"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (value.amtdeduct_spous),
        expression: "value.amtdeduct_spous"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('decimal:2|max:12'),
        expression: "'decimal:2|max:12'"
      }],
      staticClass: "form-control input-text",
      attrs: {
        "type": "text",
        "maxlength": "12",
        "data-vv-name": 'amtdeduct_spous-2-' + index,
        "data-vv-as": 'amtdeduct_spous-2-' + index,
        "has-error": _vm.errors.has('amtdeduct_spous-2-' + index)
      },
      domProps: {
        "value": (value.amtdeduct_spous)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(value, "amtdeduct_spous", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon input-group-addon-cust"
    }, [_vm._v(_vm._s(_vm.constLabels[_vm.nowLang]['bath']))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('amtdeduct_spous-2-' + index)),
        expression: "errors.has('amtdeduct_spous-2-' + index)"
      }],
      staticClass: "text-error"
    }, [_vm._v(_vm._s(_vm.errors.first('amtdeduct_spous-2-' + index)))])])])])])]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 pull-left"
  }, [_c('div', {
    staticClass: "col-xs-12 card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic3
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC16']['140']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic3),
      expression: "subTopic3"
    }],
    staticClass: "data-box clearfix"
  }, [_vm._l((_vm.detail.table3.rows), function(value, index) {
    return [_c('div', {
      staticClass: "table-row clearfix"
    }, [_c('div', {
      staticClass: "col-xs-12 body-table-left color-skin"
    }, [_vm._v(_vm._s(value.coddeduct) + " - " + _vm._s(value.desdeduct))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 body-table-right"
    }, [_c('div', {
      staticClass: "data-table-row"
    }, [_c('div', {
      staticClass: "col-xs-5 table-label"
    }, [_vm._v(_vm._s(_vm.labels['HRES32EC16']['50']))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 table-input"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (value.amtdeduct),
        expression: "value.amtdeduct"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('decimal:2|max:12'),
        expression: "'decimal:2|max:12'"
      }],
      staticClass: "form-control input-text",
      attrs: {
        "type": "text",
        "maxlength": "12",
        "data-vv-name": 'amtdeduct-3-' + index,
        "data-vv-as": 'amtdeduct-3-' + index,
        "has-error": _vm.errors.has('amtdeduct-3-' + index)
      },
      domProps: {
        "value": (value.amtdeduct)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(value, "amtdeduct", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon input-group-addon-cust"
    }, [_vm._v(_vm._s(_vm.constLabels[_vm.nowLang]['bath']))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('amtdeduct-3-' + index)),
        expression: "errors.has('amtdeduct-3-' + index)"
      }],
      staticClass: "text-error"
    }, [_vm._v(_vm._s(_vm.errors.first('amtdeduct-3-' + index)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 body-table-right"
    }, [_c('div', {
      staticClass: "data-table-row"
    }, [_c('div', {
      staticClass: "col-xs-5 table-label"
    }, [_vm._v(_vm._s(_vm.labels['HRES32EC16']['50']) + " (" + _vm._s(_vm.constLabels[_vm.nowLang]['spouse']) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 table-input"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (value.amtdeduct_spous),
        expression: "value.amtdeduct_spous"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('decimal:2|max:12'),
        expression: "'decimal:2|max:12'"
      }],
      staticClass: "form-control input-text",
      attrs: {
        "type": "text",
        "maxlength": "12",
        "data-vv-name": 'amtdeduct_spous-3-' + index,
        "data-vv-as": 'amtdeduct_spous-3-' + index,
        "has-error": _vm.errors.has('amtdeduct_spous-3-' + index)
      },
      domProps: {
        "value": (value.amtdeduct_spous)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(value, "amtdeduct_spous", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon input-group-addon-cust"
    }, [_vm._v(_vm._s(_vm.constLabels[_vm.nowLang]['bath']))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('amtdeduct_spous-3-' + index)),
        expression: "errors.has('amtdeduct_spous-3-' + index)"
      }],
      staticClass: "text-error"
    }, [_vm._v(_vm._s(_vm.errors.first('amtdeduct_spous-3-' + index)))])])])])])]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray pull-left",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.togglePage(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), (_vm.validateStaappr) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.callSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d566fac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres32e/tab2_6.vue
// module id = 3845
// module chunks = 1